type UIActionHandler = (payload: Record<string, unknown>) => void

class MarleeUIActionBus {
    private listeners: Map<string, Set<UIActionHandler>> = new Map()

    on(actionType: string, handler: UIActionHandler): () => void {
        if (!this.listeners.has(actionType)) {
            this.listeners.set(actionType, new Set())
        }
        this.listeners.get(actionType)!.add(handler)

        return () => {
            this.listeners.get(actionType)?.delete(handler)
        }
    }

    emit(actionType: string, payload: Record<string, unknown> = {}): void {
        this.listeners.get(actionType)?.forEach((handler) => {
            try {
                handler(payload)
            } catch {
                // Silently catch handler errors to avoid breaking the bus
            }
        })
    }

    removeAll(): void {
        this.listeners.clear()
    }
}

export const marleeUIActionBus = new MarleeUIActionBus()
